import { ACCOUNT_ROLES } from '@/constants/account-roles';
import { COMMUNITY_ROLES } from '@/constants/community-roles';
import { USER_ROLES } from '@/constants/user-roles';

import type { NavItemConfig } from '@/types/v2/nav';
import { config } from '@/config';
import { paths } from '@/paths';

export interface LayoutConfig {
  navItems: NavItemConfig[];
  bottomNavItems: NavItemConfig[];
}

export const layoutConfig = {
  navItems: [
    {
      key: '',
      title: '',
      items: [
        // {
        //   key: 'dashboard',
        //   title: 'Dashboard',
        //   href: paths.home,
        //   icon: 'chart-line',
        //   roles: ['super_admin', 'admin', ],
        // },
        // {
        //   key: 'accounts',
        //   title: 'Accounts',
        //   href: paths.accounts.index,
        //   icon: 'building-office',
        //   matcher: {
        //     type: 'startsWith',
        //     href: paths.accounts.index,
        //   },
        //   roles: ['super_admin', 'admin'],
        // },
        // {
        //   key: 'invitations',
        //   title: 'Invitations',
        //   href: paths.invitations.index,
        //   icon: 'envelope',
        //   roles: ['super_admin', 'admin'],
        // },
        // {
        //   key: 'transactions',
        //   title: 'Transactions',
        //   href: paths.transactions.index,
        //   icon: 'arrows-down-up',
        //   roles: ['super_admin', 'admin'],
        //   disabled: true,
        // },
        // {
        //   key: 'activity-log',
        //   title: 'Activity Log',
        //   href: paths.activity.index,
        //   icon: 'notepad',
        //   roles: ['super_admin', 'admin'],
        //   disabled: true,
        // },
        // {
        //   key: 'users',
        //   title: 'Users',
        //   href: paths.users.index,
        //   icon: 'users',
        //   matcher: {
        //     type: 'startsWith',
        //     href: paths.users.index,
        //   },
        //   roles: ['super_admin', 'admin'],
        // },
        { key: 'home', title: 'Home', href: paths.home, icon: 'house' },
        {
          key: 'calendar',
          title: 'Calendar & Events',
          href: paths.calendar.index,
          icon: 'calendar',
          roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER],
        },

        // {
        //   key: 'payments',
        //   title: 'Payments',
        //   href: paths.payments,
        //   icon: 'credit-card',
        //   disabled: true,
        //   roles: ['user'],
        // },
        {
          key: 'documents',
          title: 'Documents',
          href: paths.documents.index,
          icon: 'folder-open',
          roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER],
          matcher: { type: 'startsWith', href: paths.documents.index },
        },
        {
          
            key: 'requests',
            title: 'Requests',
            href: paths.requests.index,
            icon: 'paper-plane-tilt',
            roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
            communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER],
            matcher: { type: 'startsWith', href: paths.requests.index },
          
        },
        
        {
          key: 'announcements',
          title: 'Announcements',
          href: paths.announcements.index,
          icon: 'megaphone-simple',
          roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER],
          matcher: { type: 'startsWith', href: paths.announcements.index },
        },
        {
          key: 'reservations',
          title: 'Reservations',
          href: paths.reservations.index,
          icon: 'calendar-check',
          roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER],
          matcher: { type: 'startsWith', href: paths.reservations.index },
        },
        {
          key: 'discussion',
          title: 'Discussion',
          href: paths.discussion,
          icon: 'chats-circle',
          roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER],
          matcher: { type: 'startsWith', href: paths.discussion },
        },
        {
          key: 'meetings',
          title: 'Meetings',
          href: paths.meetings.index,
          icon: 'presentation-chart',
          roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER, COMMUNITY_ROLES.BOARD_MEMBER],
          matcher: { type: 'startsWith', href: paths.meetings.index },
        },
        {
          key: 'help',
          title: 'Help',
          href: paths.help.index,
          icon: 'graduation-cap',
          matcher: { type: 'startsWith', href: paths.help.index },
        },
      ],
    },
    {
      key: 'management',
      title: 'Management',
      // ACCOUNT_OWNER was missing while the Users/Units items below already list
      // it, so an owner was filtered out at the section before their own items
      // were ever considered. BOARD_MEMBER is stated explicitly here too, though
      // effectiveCommunityRoles() would also elevate it.
      accountRoles: [
        ACCOUNT_ROLES.ACCOUNT_OWNER,
        ACCOUNT_ROLES.ACCOUNT_ADMIN,
        ACCOUNT_ROLES.ACCOUNT_MANAGER,
      ],
      communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.BOARD_MEMBER],
      items: [
        // {
        //   key: 'forums',
        //   title: 'Forums',
        //   href: paths.forums.index,
        //   icon: 'chats-circle',
        //   roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
        //   communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER],
        //   matcher: { type: 'startsWith', href: paths.forums.index },
        // },
        {
          key: 'users',
          title: 'Users',
          href: paths.users.index,
          icon: 'users',
          roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.BOARD_MEMBER],
          matcher: { type: 'startsWith', href: paths.users.index },
        },
        {
          key: 'units',
          title: 'Units',
          href: paths.units.index,
          icon: 'house-line',
          roles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.BOARD_MEMBER],
          matcher: { type: 'startsWith', href: paths.units.index },
        },
      ],
    },
    {
      key: 'settings',
      title: 'Settings',
      accountRoles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
      communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.BOARD_MEMBER],
      items: [
        {
          key: 'community-settings',
          title: 'Community Settings',
          href: paths.settings.community.index,
          icon: 'building-office',
          accountRoles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          communityRoles: [COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.BOARD_MEMBER],
          matcher: {
            type: 'startsWith',
            href: paths.settings.community.index,
          },
        },
        {
          key: 'account-settings',
          title: 'Account Settings',
          href: paths.settings.account.index,
          icon: 'gear',
          accountRoles: [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER],
          matcher: {
            type: 'startsWith',
            href: paths.settings.account.index,
          },
        },
      ],
    },
  ],
  bottomNavItems: [],
} as LayoutConfig;
